/* Kemio · carrito tipo hoja (móvil) — complementa el cart-drawer de Sense/Dawn sin tocar el snippet.
   Inyecta: asa, barra de envío gratis, desplegables Envío/Descuento, botón «Ver carrito»
   y renombra textos. Se reaplica cada vez que el tema re-renderiza el cajón. */
(function () {
  if (window.__kemioHoja) return; window.__kemioHoja = true;
  var UMBRAL = 3500; // céntimos: envío gratis desde 35 € (España peninsular)
  var eur = function (c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); };
  var ultimoTotal = null;

  function barraHTML(total) {
    var falta = Math.max(0, UMBRAL - total), pct = Math.min(100, Math.round((total / UMBRAL) * 100));
    var txt = falta > 0 ? 'Te faltan <strong>' + eur(falta) + '</strong> para el <strong>envío gratis</strong>'
                        : '¡Tienes <strong>envío gratis</strong>! 🎉';
    return '<p class="hoja-envio__texto">' + txt + '</p><div class="hoja-envio__pista" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
  }
  var pintarBarra = function (total) {
    if (total == null) return;
    ultimoTotal = total;
    document.querySelectorAll('.hoja-envio').forEach(function (b) { b.innerHTML = barraHTML(total); });
  };
  function actualizarTotal() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { pintarBarra(c.total_price); }).catch(function () {});
  }

  function caret() {
    return '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';
  }

  function decorar() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    if (!inner.querySelector(':scope > .hoja-asa')) {
      var asa = document.createElement('div');
      asa.className = 'hoja-asa'; asa.setAttribute('aria-hidden', 'true');
      inner.insertBefore(asa, inner.firstChild);
      asa.addEventListener('click', function () { drawer.close(); });
    }
    var header = inner.querySelector('.drawer__header');
    if (header && !inner.querySelector('.hoja-envio')) {
      var b = document.createElement('div'); b.className = 'hoja-envio';
      header.insertAdjacentElement('afterend', b);
      if (ultimoTotal != null) b.innerHTML = barraHTML(ultimoTotal);
    }
    var footer = inner.querySelector('.drawer__footer');
    if (footer && !footer.querySelector('.hoja-extra')) {
      var nota = footer.querySelector('#Details-CartDrawer .summary__title');
      if (nota && nota.firstChild && nota.firstChild.nodeType === 3 && nota.firstChild.nodeValue !== 'Nota del pedido ') nota.firstChild.nodeValue = 'Nota del pedido ';
      var ta = footer.querySelector('#CartDrawer-Note'); if (ta && ta.placeholder !== '¿Algo que debamos saber? (opcional)') ta.placeholder = '¿Algo que debamos saber? (opcional)';
      var extra = document.createElement('div'); extra.className = 'hoja-extra';
      extra.innerHTML =
        '<details class="hoja-det"><summary><span class="summary__title">Gastos de envío ' + caret() + '</span></summary>' +
        '<div class="hoja-det__cuerpo"><p>Envío <strong>gratis desde 35 €</strong> en España peninsular. Para pedidos menores, el coste se calcula en la caja según la dirección.</p></div></details>' +
        '<details class="hoja-det"><summary><span class="summary__title">Descuento ' + caret() + '</span></summary>' +
        '<div class="hoja-det__cuerpo"><form class="hoja-descuento"><div class="field"><input class="field__input" type="text" name="codigo" placeholder="Código de descuento" autocomplete="off" aria-label="Código de descuento"></div>' +
        '<button type="submit" class="button button--secondary">Aplicar</button></form>' +
        '<p class="hoja-det__nota">El descuento se aplica en la caja.</p></div></details>';
      var det = footer.querySelector('#Details-CartDrawer');
      if (det) det.insertAdjacentElement('afterend', extra); else footer.insertBefore(extra, footer.firstChild);
      // Mover la nota dentro del grupo para que los tres desplegables vayan juntos
      if (det) extra.insertBefore(det, extra.firstChild);
      extra.querySelector('.hoja-descuento').addEventListener('submit', function (e) {
        e.preventDefault();
        var c = (this.codigo.value || '').trim();
        window.location.href = c ? '/checkout?discount=' + encodeURIComponent(c) : '/checkout';
      });
    }
    var ctas = inner.querySelector('.cart__ctas');
    if (ctas && !ctas.querySelector('.hoja-ver')) {
      var ver = document.createElement('a');
      ver.href = (window.routes && window.routes.cart_url) || '/cart';
      ver.className = 'button button--secondary hoja-ver'; ver.textContent = 'Ver carrito';
      ctas.insertBefore(ver, ctas.firstChild);
    }
    var pay = inner.querySelector('#CartDrawer-Checkout');
    if (pay && pay.textContent.trim() !== 'Ir a la caja') pay.textContent = 'Ir a la caja';
    // Antes: tit.textContent = 'Total' en cada pasada -> mutación childList -> observer -> rAF -> bucle infinito a 60 fps
    var tit = inner.querySelector('.totals__total');
    if (tit && tit.textContent.trim() !== 'Total') tit.textContent = 'Total';
  }

  var drawer = null, mo = null, sucio = true, rafId = 0;
  var OPTS = { childList: true, subtree: true };
  function abierto() { return !!(drawer && drawer.classList.contains('active')); }
  function decorarSeguro() {
    // Desconectar mientras mutamos para no re-dispararnos
    if (mo) mo.disconnect();
    try { decorar(); if (ultimoTotal != null) pintarBarraSiCambia(); } finally { sucio = false; if (mo && drawer) mo.observe(drawer, OPTS); }
  }
  function pintarBarraSiCambia() {
    var html = barraHTML(ultimoTotal);
    document.querySelectorAll('.hoja-envio').forEach(function (b) { if (b.__k !== html) { b.innerHTML = html; b.__k = html; } });
  }
  pintarBarra = function (total) {
    if (total == null) return; ultimoTotal = total;
    if (mo) mo.disconnect(); pintarBarraSiCambia(); if (mo && drawer) mo.observe(drawer, OPTS);
  };
  function programar() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = 0; decorarSeguro(); });
  }
  function sync() { document.documentElement.classList.toggle('hoja-abierta', abierto()); }

  function iniciar() {
    drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    sync();
    // Re-render del tema: si está cerrado, solo marcamos sucio (cero trabajo)
    mo = new MutationObserver(function () {
      sucio = true;
      if (abierto()) { programar(); actualizarPronto(); }
    });
    mo.observe(drawer, OPTS);
    new MutationObserver(function () {
      var era = document.documentElement.classList.contains('hoja-abierta');
      sync();
      if (abierto() && !era) { if (sucio) decorarSeguro(); actualizarTotal(); }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (abierto()) { decorarSeguro(); actualizarTotal(); }
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sucio = true; actualizarTotal(); });
    window.addEventListener('dock:cart-changed', actualizarTotal);
    document.addEventListener('cart:update', actualizarTotal);
  }
  var tFetch = 0;
  function actualizarPronto() { clearTimeout(tFetch); tFetch = setTimeout(actualizarTotal, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
